import { SocialMediaPlatformsEnum } from '@brand-lolly/app/_models/platforms';
import { ReportBlockCreator, ReportBlockData } from './report-blocks.service';

/**
 * A Creator shortlist: the creators talking about you, one card per account
 * (`reports/blocks/creators.py`).
 *
 * The accounts are Top voices' own read over the report's window, with the
 * same mentions and the same order, so a card never disagrees with the
 * table. Followers are the one figure on a card that is not the window's:
 * they are what the account's profile shows, and every surface says so.
 *
 * A card opens the creator's Discovery profile in the editor alone. The
 * share page and the PDF are read by people outside the account, for whom
 * the profile is a sign-in page, so they draw the same cards with no link.
 */

/** Discovery keeps profiles for these three networks, and no other. */
const DISCOVERY_PLATFORMS: Readonly<Record<string, SocialMediaPlatformsEnum>> =
	{
		instagram: SocialMediaPlatformsEnum.INSTAGRAM,
		tiktok: SocialMediaPlatformsEnum.TIKTOK,
		youtube: SocialMediaPlatformsEnum.YOUTUBE
	};

/**
 * Whether a drawn block is a Creator shortlist. Read off its shape, which the
 * answer carries; a shortlist whose read failed has none and is drawn like
 * any block that could not be read.
 */
export function isCreatorsBlock(
	block: Pick<ReportBlockData, 'shape'> | null | undefined
): boolean {
	return block?.shape === 'creators';
}

/**
 * The network a creator's Discovery profile opens on, or null when there is
 * no profile to open: no Discovery id, or a network Discovery does not keep.
 */
export function discoveryProfilePlatform(
	creator: ReportBlockCreator
): SocialMediaPlatformsEnum | null {
	if (creator.discovery_id == null) {
		return null;
	}
	return DISCOVERY_PLATFORMS[creator.platform] ?? null;
}
